import Vue from 'vue';
import Vuex from 'vuex';

import common from './modules/common';
import reports from './modules/reports';
import patients from './modules/patients';
import coaching from './modules/coaching';
import singlePatient from './modules/singlePatient';
import coachingSupervisor from './modules/coachingSupervisor';
import patientClinicalCoaching from './modules/patientClinicalCoaching';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    common,
    reports,
    patients,
    coaching,
    singlePatient,
    coachingSupervisor,
    patientClinicalCoaching
  }
});
